import { isSiteDomain } from "../../settings/domainManager";

export function navigate_to_edit_profile(next_link = null) {
  let url = "/editProfile";
  if (next_link && next_link?.includes("?")) {
    url += "&_next=" + next_link;
  }
  if (next_link && !next_link?.includes("?")) {
    url += "?_next=" + next_link;
  }
  return url;
}

export function navigate_to_profile() {
  if (isSiteDomain) {
    return "/";
  } else {
    return "/profile";
  }
}
